import { DialogActions, styled } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { IconApproved, IconCancel } from 'assets/img';
import { LwButton } from 'redesign';
import { useTranslation } from 'react-i18next';
import { BulkForwardFormInput, SelectableFor } from '../types';

type Props = {
  selectableFor: SelectableFor;
  closeDialog: () => void;
};

export const BulkForwardDialogActions = ({ selectableFor, closeDialog }: Props) => {
  const { watch } = useFormContext<BulkForwardFormInput>();
  const { t } = useTranslation('web-common');

  return (
    <CenteredDialogActions>
      <LwButton
        iconColorMode="stroke"
        startIcon={<IconCancel />}
        color="secondary"
        type="button"
        onClick={closeDialog}
      >
        {t('buttons.cancel', { ns: 'web-common' })}
      </LwButton>
      <LwButton
        iconColorMode="stroke"
        startIcon={<IconApproved />}
        color="primary"
        disabled={selectableFor === SelectableFor.None || !watch('partners')?.length}
        type="submit"
      >
        {t('buttons.add', { ns: 'web-common' })}
      </LwButton>
    </CenteredDialogActions>
  );
};

const CenteredDialogActions = styled(DialogActions)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.grey[200]}`,
  padding: theme.spacing(5),
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  position: 'absolute',
  bottom: 20,
  width: '100%',
  backgroundColor: theme.palette.background.paper,
}));
